export const NOVA_NAME = "Nova";

export const NOVA_TITLE = "Voice guide";

export const NOVA_TAGLINE =
  "I'll ask for each field out loud so you can keep your hands free.";

export const NOVA_PRIVACY_NOTE =
  "Nova runs in your browser. What you say stays on this page and is not sent to an outside AI.";

/** Light teal-green from the VetNebula wordmark ("Vet") and logo V. */
export const NOVA_COLORS = {
  brand: "#30A890",
  brandDark: "#1E7A68",
  brandDeep: "#165E52",
  mint: "#7ED9C4",
  mintLight: "#C8F3E8",
  mintWash: "#E7FAF5",
  panel: "#F3FBF8",
};

/** Higher, lighter than the default system voice. Pitch range is 0–2. */
export const NOVA_VOICE = {
  pitch: 1.48,
  rate: 1.06,
};

const FEMININE_VOICE_NAME =
  /samantha|victoria|karen|moira|tessa|zira|fiona|veena|allison|ava|susan|nicky|helena|sara|sofia|linda|hazel|aria|jenny|siri|female|google us english|microsoft zira|karen|fiona/i;

export const pickNovaVoice = (
  voices: SpeechSynthesisVoice[],
): SpeechSynthesisVoice | undefined => {
  const english = voices.filter((voice) => /^en\b/i.test(voice.lang));
  const pool = english.length > 0 ? english : voices;
  return (
    pool.find((voice) => FEMININE_VOICE_NAME.test(voice.name)) ||
    pool.find((voice) => /female/i.test(voice.name)) ||
    pool[0]
  );
};

/**
 * Name options considered for the VetNebula voice pet.
 * Implemented as Nova (short, easy to speak, nebula/star).
 */
export const VETNEBULA_PET_NAME_SUGGESTIONS = [
  {
    name: "Nova",
    why: "A bright star born in a nebula. Short, easy for voice, already matches the nova-burst store animation.",
  },
  {
    name: "Vega",
    why: "One of the brightest stars in the sky; sounds adjacent to “vet”.",
  },
  {
    name: "Polaris",
    why: "The guide star — walks learners and coaches through the form.",
  },
  {
    name: "Nebbie",
    why: "Playful take on nebula; pairs with the existing nebula-otter pet.",
  },
  {
    name: "Lyra",
    why: "A constellation and a musical instrument — fits a talking companion.",
  },
] as const;
